/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClientLight,
    ClientLightFromJSON,
    ClientLightFromJSONTyped,
    ClientLightToJSON,
    UserGroup,
    UserGroupFromJSON,
    UserGroupFromJSONTyped,
    UserGroupToJSON,
    UserRole,
    UserRoleFromJSON,
    UserRoleFromJSONTyped,
    UserRoleToJSON,
    UserTokenUserNestedExternalSystem,
    UserTokenUserNestedExternalSystemFromJSON,
    UserTokenUserNestedExternalSystemFromJSONTyped,
    UserTokenUserNestedExternalSystemToJSON,
} from './';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    clientId?: number;
    /**
     * 
     * @type {ClientLight}
     * @memberof User
     */
    client?: ClientLight;
    /**
     * 
     * @type {Array<UserGroup>}
     * @memberof User
     */
    readonly userGroup?: Array<UserGroup>;
    /**
     * 
     * @type {Array<number>}
     * @memberof User
     */
    userGroupIds?: Array<number>;
    /**
     * 
     * @type {Array<UserRole>}
     * @memberof User
     */
    readonly userRoles?: Array<UserRole>;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    userRolesIds: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    lastLogin?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    ssoId?: string | null;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    loginCredentials?: object | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    surname: string;
    /**
     * 
     * @type {object}
     * @memberof User
     */
    contact?: object | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    deleted: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    active: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    averageSpeed: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    languageIso6391?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    password?: string | null;
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof User
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    isContactPerson?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    binaryRights?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    externalId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    binaryRightsBackup?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    isSsoAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    binaryRightsDirty?: boolean;
    /**
     * 
     * @type {UserTokenUserNestedExternalSystem}
     * @memberof User
     */
    externalSystem?: UserTokenUserNestedExternalSystem;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'clientId': !exists(json, 'client_id') ? undefined : json['client_id'],
        'client': !exists(json, 'client') ? undefined : ClientLightFromJSON(json['client']),
        'userGroup': !exists(json, 'user_group') ? undefined : ((json['user_group'] as Array<any>).map(UserGroupFromJSON)),
        'userGroupIds': !exists(json, 'user_group_ids') ? undefined : json['user_group_ids'],
        'userRoles': !exists(json, 'user_roles') ? undefined : ((json['user_roles'] as Array<any>).map(UserRoleFromJSON)),
        'userRolesIds': json['user_roles_ids'],
        'lastLogin': !exists(json, 'last_login') ? undefined : (json['last_login'] === null ? null : new Date(json['last_login'])),
        'ssoId': !exists(json, 'sso_id') ? undefined : json['sso_id'],
        'loginCredentials': !exists(json, 'login_credentials') ? undefined : json['login_credentials'],
        'name': json['name'],
        'surname': json['surname'],
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'deleted': json['deleted'],
        'active': json['active'],
        'averageSpeed': json['average_speed'],
        'languageIso6391': !exists(json, 'language_iso_639_1') ? undefined : json['language_iso_639_1'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'isActive': !exists(json, 'is_active') ? undefined : json['is_active'],
        'isContactPerson': !exists(json, 'is_contact_person') ? undefined : json['is_contact_person'],
        'binaryRights': !exists(json, 'binary_rights') ? undefined : json['binary_rights'],
        'externalId': !exists(json, 'external_id') ? undefined : json['external_id'],
        'binaryRightsBackup': !exists(json, 'binary_rights_backup') ? undefined : json['binary_rights_backup'],
        'isSsoAdmin': !exists(json, 'is_sso_admin') ? undefined : json['is_sso_admin'],
        'binaryRightsDirty': !exists(json, 'binary_rights_dirty') ? undefined : json['binary_rights_dirty'],
        'externalSystem': !exists(json, 'external_system') ? undefined : UserTokenUserNestedExternalSystemFromJSON(json['external_system']),
    };
}

export function UserToJSON(value?: User | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'client_id': value.clientId,
        'client': ClientLightToJSON(value.client),
        'user_group_ids': value.userGroupIds,
        'user_roles_ids': value.userRolesIds,
        'last_login': value.lastLogin === undefined ? undefined : (value.lastLogin === null ? null : value.lastLogin.toISOString()),
        'sso_id': value.ssoId,
        'login_credentials': value.loginCredentials,
        'name': value.name,
        'surname': value.surname,
        'contact': value.contact,
        'note': value.note,
        'deleted': value.deleted,
        'active': value.active,
        'average_speed': value.averageSpeed,
        'language_iso_639_1': value.languageIso6391,
        'password': value.password,
        'is_active': value.isActive,
        'is_contact_person': value.isContactPerson,
        'binary_rights': value.binaryRights,
        'external_id': value.externalId,
        'binary_rights_backup': value.binaryRightsBackup,
        'is_sso_admin': value.isSsoAdmin,
        'binary_rights_dirty': value.binaryRightsDirty,
        'external_system': UserTokenUserNestedExternalSystemToJSON(value.externalSystem),
    };
}


